module.exports = __webpack_public_path__ + "static/img/thumb-01.f21d114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/thumb/thumb-01.png
// module id = PMIi
// module chunks = 31